<template>
  <div class="wrapper">
    <div style="margin: 200px auto; background-color: #fff;width: 350px;height: 300px; padding: 20px;border-radius: 10px">
      <div style="margin: 20px 0; text-align: center; font-size: 24px"><b>登录</b></div>
      <el-input size="medium" style="margin: 10px 0" prefix-icon="el-icon-user" v-model="user.username" placeholder="请输入用户名"></el-input>
      <el-input size="medium" style="margin: 10px 0" prefix-icon="el-icon-lock" show-password v-model="user.password" placeholder="请输入密码"></el-input>
      <div style="margin: 10px 0; text-align: center">
        <el-button type="primary" size="small" aria-autocomplete="off" @click="login"  >登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/request/request'
import util from '@/util/util'
export default {
  data() {
    return {
      user: {},
      dynamicValidateForm: {
        domains: [{
          value: ''
        }],
        email: ''
      },
      loading: ''
    };
  },
  methods: {
    login () {
      this.showLoading()
      let str = `/login_proxy?username=${this.user.username}&password=${this.user.password}`
      request.get(str).then(res => {
        this.hideLoading();
        util.log("login2",res)
        if (res.code === "0") {
          localStorage.setItem("token", res.data)
          this.$router.push('/main')
        } else {
          alert(res.desc)
        }
      }).catch(e => {
        this.hideLoading();
        alert(e.message)
      })
    },

    showLoading(){
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    hideLoading(){
      this.loading.close();
    }
  }
}
</script>

<style>
  .wrapper {
    height: 100vh;
    background-image: linear-gradient(to bottom right,#42b983,#555555,#3190e8);
    overflow: hidden;
  }

</style>
